/* adv-pageflow — carosello specchiato delle pagine (Apertura dei giochi).
   Trascina, frecce o tastiera per scorrere; nessun clic, zoom o salvataggio. */
(function () {
  if (window.__advPageflow) return; window.__advPageflow = true;
  var X = [0, .603, 1.087, 1.485, 1.85], S = [1, .833, .722, .622, .54];
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function lerp(a, b, t) { return a + (b - a) * t; }
  function at(arr, d) { var i = Math.floor(d); if (i >= arr.length - 1) return arr[arr.length - 1]; return lerp(arr[i], arr[i + 1], d - i); }
  function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

  function init(stage) {
    if (stage.__pf) return; stage.__pf = true;
    var items = [].slice.call(stage.querySelectorAll('.adv-pf__it')), n = items.length;
    if (n < 2) return;
    var cur = +stage.getAttribute('data-start') || 0, hc = 380, anim = null, timer = null, visible = true, hover = false, lastUser = 0;
    var vis = Math.min(3, Math.floor((n - 1) / 2));          // pagine visibili per lato

    function size() {
      var w = stage.clientWidth, mob = window.innerWidth < 750;
      var max = parseFloat(getComputedStyle(stage.parentNode).getPropertyValue('--pf-max')) || 1400;
      hc = mob ? Math.min(w * .58, 320) : Math.min(Math.min(w, max) / 3.45, 470);
      stage.style.setProperty('--hc', hc.toFixed(1) + 'px');
      render();
    }
    function wrap(d) { d = ((d % n) + n) % n; if (d > n / 2) d -= n; return d; }
    function render() {
      for (var i = 0; i < n; i++) {
        var d = wrap(i - cur), a = Math.abs(d), sg = d < 0 ? -1 : 1;
        var x = at(X, Math.min(a, 4)) * sg, s = at(S, Math.min(a, 4));
        var o = a <= vis ? 1 : Math.max(0, 1 - (a - vis) * 2);
        var el = items[i];
        el.style.transform = 'translateX(' + (x * hc).toFixed(1) + 'px) scale(' + s.toFixed(4) + ')';
        el.style.opacity = o.toFixed(3);
        el.style.zIndex = String(50 - Math.round(a * 4));
        el.style.visibility = o < .01 ? 'hidden' : 'visible';
        if (a < .5) el.removeAttribute('aria-hidden'); else el.setAttribute('aria-hidden', 'true');
      }
    }
    function goTo(target, dur) {
      if (anim) cancelAnimationFrame(anim.raf);
      var from = cur, t0 = performance.now(); dur = reduce ? 0 : (dur || 650);
      if (!dur) { cur = target; norm(); render(); return; }
      anim = { raf: 0 };
      (function step(now) {
        var t = Math.min(1, (now - t0) / dur); cur = from + (target - from) * ease(t); render();
        if (t < 1) anim.raf = requestAnimationFrame(step); else { anim = null; norm(); }
      })(t0);
    }
    function norm() { cur = ((cur % n) + n) % n; }
    function step(k) { lastUser = Date.now(); goTo(Math.round(cur) + k); }

    // trascinamento (mouse e dito); lo scorrimento verticale della pagina resta libero
    var down = false, sx = 0, sy = 0, sc = 0, moved = false, lx = 0, lt = 0, vx = 0, pid = null;
    stage.addEventListener('pointerdown', function (e) {
      if (e.target.closest('[data-pf-prev],[data-pf-next]')) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      down = true; moved = false; sx = lx = e.clientX; sy = e.clientY; sc = cur; lt = performance.now(); vx = 0; pid = e.pointerId;
      if (anim) { cancelAnimationFrame(anim.raf); anim = null; }
      lastUser = Date.now();
    });
    stage.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== pid) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (!moved) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        if (Math.abs(dy) > Math.abs(dx)) { down = false; return; }   // gesto verticale: lascia scorrere la pagina
        moved = true; stage.classList.add('is-drag');
        try { stage.setPointerCapture(pid); } catch (er) {}
      }
      var now = performance.now(); vx = (e.clientX - lx) / Math.max(1, now - lt); lx = e.clientX; lt = now;
      cur = sc - dx / (hc * .62); render(); e.preventDefault();
    });
    function up() {
      if (!down) return; down = false; stage.classList.remove('is-drag');
      if (!moved) return;
      var fling = -vx * 220 / (hc * .62);
      goTo(Math.round(cur + Math.max(-2, Math.min(2, fling))), 520); lastUser = Date.now();
    }
    stage.addEventListener('pointerup', up); stage.addEventListener('pointercancel', up); stage.addEventListener('lostpointercapture', up);
    // niente clic, trascinamento delle immagini, menu "salva immagine"
    ['click', 'dblclick', 'dragstart', 'contextmenu', 'selectstart'].forEach(function (ev) {
      stage.addEventListener(ev, function (e) { if (!e.target.closest('[data-pf-prev],[data-pf-next]')) e.preventDefault(); }, true);
    });
    stage.querySelector('[data-pf-prev]').addEventListener('click', function () { step(-1); });
    stage.querySelector('[data-pf-next]').addEventListener('click', function () { step(1); });
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { step(-1); e.preventDefault(); }
      if (e.key === 'ArrowRight') { step(1); e.preventDefault(); }
    });
    // scorrimento orizzontale con il trackpad
    var wacc = 0, wt = 0;
    stage.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault(); var now = Date.now(); if (now - wt > 400) wacc = 0; wt = now; wacc += e.deltaX;
      if (Math.abs(wacc) > 60) { step(wacc > 0 ? 1 : -1); wacc = 0; }
    }, { passive: false });

    // scorrimento automatico lento, si ferma quando il visitatore interagisce
    stage.addEventListener('mouseenter', function () { hover = true; });
    stage.addEventListener('mouseleave', function () { hover = false; });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: .25 }).observe(stage);
    if (!reduce) timer = setInterval(function () {
      if (!visible || hover || down || anim || document.hidden || Date.now() - lastUser < 7000) return;
      goTo(Math.round(cur) + 1, 900);
    }, 3400);

    window.addEventListener('resize', size);
    lastUser = Date.now();                                  // primo scorrimento automatico dopo qualche secondo
    size(); stage.classList.add('is-ready');
  }
  function boot() { [].forEach.call(document.querySelectorAll('[data-pf]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
